// Test tipleri

import type { QuestionOption } from './question';

export type TestStatus = 'draft' | 'active' | 'archived';

export interface TestSettings {
  // Sunum biçimi
  viewMode: 'step-by-step' | 'scroll';    // Soru soru / Scroll
  viewModeLocked: boolean;                  // Öğretmen kilitlediyse true
  // Zamanlayıcı
  hasTimer: boolean;
  timerSeconds?: number;                    // 0 = süresiz
  timerLocked: boolean;
  // Geri bildirim
  instantFeedback: boolean;                 // Anlık doğru/yanlış
  feedbackLocked: boolean;
  // Shuffling
  shuffleQuestions: boolean;
  shuffleOptions: boolean;
  shuffleLocked: boolean;
  // Çıktı
  fontSize?: number;
  fontFamily?: string;
  isDoubleColumn?: boolean;
  orientation?: 'portrait' | 'landscape';
  // A4 çıktı üst/alt bilgisi
  schoolName?: string;
  teacherNameOverride?: string;
  footerText?: string;
  // A4 kağıt önizleme (öğretmen düzeltme ekranı)
  showAnswerKey?: boolean;
  showSolutionArea?: boolean;
  solutionsOnNewPage?: boolean;
  /** A4 sayfa teması — 'osym' ÖSYM tarzı kod kutusu/rozet/talimat kutusu kullanır (logo/filigran yok) */
  theme?: 'bitmiyo' | 'osym';
  /** Maksimum Soru Sığdır (Sıkı Yerleşim) */
  tightPagination?: boolean;
  /** Sayfa Altı Boşluklarını Dengele (Orantılı Yayım) */
  balancedLayout?: boolean;
}

export const DEFAULT_TEST_SETTINGS: TestSettings = {
  viewMode: 'step-by-step',
  viewModeLocked: false,
  hasTimer: false,
  timerLocked: false,
  instantFeedback: true,
  feedbackLocked: false,
  shuffleQuestions: false,
  shuffleOptions: false,
  shuffleLocked: false,
};

export interface Test {
  id: string;                               // UUID
  author_id: string;                        // Clerk user_id
  title: string;
  description?: string;
  lesson?: string;
  grade_level?: string;
  question_ids: string[];                   // UUID[]
  settings?: TestSettings;
  share_code?: string;                      // Paylaşım kodu
  status: TestStatus;
  /** true ise test, Testleri Keşfet sayfasında öğrencilere açık şekilde listelenir */
  is_public?: boolean;
  /** İçerik dondurulmuş mu? true ise soru listesi/cevap anahtarı değiştirilemez */
  is_locked?: boolean;
  locked_at?: string;
  created_at: string;
  updated_at: string;
}

export type TestDraft = Omit<Test, 'id' | 'author_id' | 'created_at' | 'updated_at' | 'locked_at'>;

/**
 * Öğrenci çözerken sorunun o anki hali — öğretmen sonradan soruyu değiştirse bile
 * kaydedilmiş sonucun/cevap anahtarının bozulmaması için.
 */
export interface QuestionSnapshot {
  content: string;
  options?: QuestionOption[];
  correct_answer?: string | boolean | null;
  /** Çözüm açıklaması — yanlış analizi ekranında gösterilir (eski sonuçlarda olmayabilir) */
  solution?: string;
}

// Test sonucu (öğrenci çözümü)
export interface TestAnswer {
  question_id: string;
  selected: string | boolean | null;        // Seçilen şık ID veya D/Y cevabı
  is_correct: boolean;
  time_ms: number;                          // Bu soruya harcanan süre
  /** Çözüm anındaki soru anlık görüntüsü (versiyon koruması) */
  question_snapshot?: QuestionSnapshot;
}

export interface TestResult {
  id: string;
  test_id: string;
  student_id: string;
  answers: TestAnswer[];
  score: number;                            // 0-100
  duration_seconds: number;
  completed_at: string;
  /** fetchMyResults/fetchTestResult'ın join ettiği test bilgisi */
  tests?: { title: string; lesson?: string };
}
